import React, { useState, useEffect, useMemo, useRef } from 'react'; 
import styles from '../styles/StarterSelection.module.css';
import { useAuthContext } from '../context/AuthContext';

const TypewriterText = ({ onComplete }) => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0); // On initialise le texte actuel
    const [displayedText, setDisplayedText] = useState(''); // On initialise le texte affiché
    const [isComplete, setIsComplete] = useState(false); // On initialise le texte comme incomplet
    const timerRef = useRef(null); // On initialise le timer
    const { user } = useAuthContext(); // On récupère l'utilisateur
    const name = user?.username || ''; // On récupère le nom de l'utilisateur
    

    const texts = useMemo(() => [   // On crée un tableau de textes avec les différents messages à afficher 
        `Salut ${name} !`,
        "Je suis le Prof' Ken",
        "...",
        "Bah quoi ? Tu t'attendais à quelqu'un d'autre ? :B",
        "Je suis pas aussi expérimenté et sage que le vieux Chen mais je ferais de mon mieux pour t'aider à débuter ton aventure correctement !",
        "Tu vas d'abord devoir choisir ton premier partenaire ! C'est un peu compliqué, c'est un choix important, alors prends ton temps !", 
        "Tu auras le choix entre 3 pokémons différents, tu peux relancer la sélection proposée 5 fois maximum, tu peux même choisir un type spécifique si nécessaire !",
        "Ensuite, tu vas aussi devoir créer, et surtout accomplir des tâches si jamais tu veux le voir grandir, évoluer, et voir même, si tu es vraiment assidu.e, en attraper d'autres !",
        "Mais assez de parlottes, je sais que tu meurs d'impatience de commencer, alors, sans plus tarder, tu vas pouvoir choisir ton premier Pokémon !",
        "Bonne chance ! :)"
    ], [name]);


    useEffect(() => {
        if (currentTextIndex >= texts.length) return; // Si on est à la fin des textes, on quitte la fonction
        
        let currentText = texts[currentTextIndex]; // On récupère le texte actuel
        let currentChar = 0; // On initialise le compteur de caractères
        setDisplayedText(''); // On réinitialise le texte affiché
        setIsComplete(false); // On marque le texte comme incomplet
        

        timerRef.current = setInterval(() => { // On met à jour le timer
            if (currentChar <= currentText.length - 1) { // On vérifie si on est pas arrivé à la fin du texte
                setDisplayedText(currentText.substring(0, currentChar + 1)); // On affiche le texte caractère par caractère
                currentChar++; // On incrémente le compteur de caractères
            } else {
                setIsComplete(true); // On marque le texte comme complet            
                clearInterval(timerRef.current); // On arrête le timer
            }
        }, 50);

        return () => clearInterval(timerRef.current); // On clear le timer lorsque le composant est démonté
    }, [currentTextIndex, texts]);  

    const handleClick = () => { // On gère le clic sur le texte
        if (!isComplete) { // Si le texte n'est pas complet
            clearInterval(timerRef.current); // On arrête le timer
            setDisplayedText(texts[currentTextIndex]); // On affiche le texte
            setIsComplete(true); // On marque le texte comme complet
        } else if (currentTextIndex < texts.length - 1) { // Si on n'est pas à la fin des textes    
            setCurrentTextIndex(prev => prev + 1); // On passe au texte suivant
        } else if (isComplete && currentTextIndex === texts.length - 1) { // Si le texte est complet et que c'est le dernier texte
            onComplete?.(); // On appelle la fonction onComplete
        }

    };

    return (
        <div className={styles.introScene_text} onClick={handleClick}> 
            <p className={styles.textContent}>
                {displayedText}
                {isComplete && (
                    <span className={styles.cursor}>▼</span>
                )}
            </p>
        </div>
    );
};

export default TypewriterText; 